import Vue from 'vue';

export default {
  ADD_FILE: (state, { file, bucket }) => {
    if (!state.files[bucket]) {
      Vue.set(state.files, bucket, []);
    }
    state.files[bucket].push(file);
  },

  DELETE_BUCKET: (state, { bucket }) => {
    delete state.files[bucket];
    state.files = Object.assign({}, state.files);
  },

  SET_FILE_STATUS: (state, { filename, bucket, status }) => {
    if (state.files[bucket]) {
      let index = state.files[bucket].findIndex(item => {
        return item.upload.filename === filename;
      });
      if (index >= 0) {
        state.files[bucket][index].status = status;
      }
    }
  },

  SET_FILE_DATA: (state, { filename, bucket, data }) => {
    if (state.files[bucket]) {
      let index = state.files[bucket].findIndex(item => {
        return item.upload.filename === filename;
      });
      if (index >= 0) {
        state.files[bucket][index] = Object.assign(state.files[bucket][index], data);
      }
    }
  },

  DELETE_FILE: (state, { filename, bucket }) => {
    if (state.files[bucket]) {
      let index = state.files[bucket].findIndex(item => {
        return item.upload.filename === filename;
      });
      state.files[bucket].splice(index, 1);
    }
  },

  CLEAR_BUCKET: (state, { bucket }) => {
    if (state.files[bucket]) {
      Vue.delete(state.files, bucket)
    }
  },

};


// WEBPACK FOOTER //
// ./src/store/uploader/mutations.js